export enum StepConnectTransferTypeEnum {
	None = "none",
	TransferProgress = "mygames",
	StartFromScratch = "new"
}
